export default __webpack_public_path__ + "static/media/filter-4.1eb978dd.png";